import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { BehaviorSubject } from 'rxjs';
import { IUserTokenDataInterface } from '../../model/commonModel';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private commonService: CommonService) {}

  getValue(key: string): any {
    const storedValue = localStorage.getItem(key);
    if (!storedValue) return null;

    try {
      const decryptedData = this.commonService.Decrypt(storedValue);
      return decryptedData;
    } catch (error) {
      console.error('Error decrypting data from local storage', error);
      return null;
    }
  }

  setValue(key: string, value: string): void {
    const encryptedValue = this.commonService.Encrypt(value);
    localStorage.setItem(key, encryptedValue);
  }

  removeValue(key: string): void {
    localStorage.removeItem(key);
  }

  clearAll(): void {
    localStorage.clear();
  }

  getTokenData(): IUserTokenDataInterface {
    const token = this.getValue(StorageKey.authToken);
    if (!token) throw 'No token avilable';

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) throw 'Invalid token';

    try {
      const decoded = JSON.parse(atob(tokenParts[1])); // Decode payload
      return JSON.parse(decoded.name);
    } catch (error) {
      throw error;
    }
  }

  private idSource = new BehaviorSubject<string | null>(null);
  currentLeadId = this.idSource.asObservable();

  setLeadId(id: string) {
    this.idSource.next(id);
  }
  public firmIdSource = new BehaviorSubject<number | null>(null);
  setFirmId(id: number) {
    this.firmIdSource.next(id);
  }
}

export class StorageKey {
  public static authToken = 'authToken';
  public static currentUserId = 'currentUserId';
  public static firstMenu = 'firstMenu';
  public static menuList = 'menuList';
}
